let moment = require('moment');
let $ = require('jquery');
let Vue = require('vue');

let getDate = (date) => {
    // Carbon do Laravel gera um objeto {"date", "timezone", "timezone_type"}
    if (date && date.hasOwnProperty('date')) {
        return date.date;
    }

    return date;
};

Vue.directive('from-now', {
    twoWay: true,
    priority: 1000,

    params: ['date'],

    bind: function () {
        let self = this;
        let date = getDate(this.params.date);

        if (date) {
            $(this.el).html(moment.utc(date).fromNow());
        }
    },
    update: function (value) {
        //let date = getDate(value);
        //$(this.el).html(moment(date).fromNow());
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/from-now.js